import { Component, Inject, InjectionToken, OnInit } from '@angular/core';

// models
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';

// services
import { PlansService } from '../../../services/plans.service';

import { SHARED_MODULES } from '../../../../shared.';
import { PhIconWrapperComponent } from '../../ph-icon-wrapper/ph-icon-wrapper.component';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

type PlanStatusButtonDtypeElement = {
	shop_id: number;
	active: boolean;
}

@Component({
    selector: 'app-plan-status-button-dtype',
    templateUrl: './plan-status-button-dtype.component.html',
    styleUrls: ['./plan-status-button-dtype.component.scss'],
	imports: [SHARED_MODULES, PhIconWrapperComponent],
    standalone: true
})
export class PlanStatusButtonDtypeComponent implements OnInit {

	public element: PlanStatusButtonDtypeElement;

	constructor(
		@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<PlanStatusButtonDtypeElement>,
		private plansService: PlansService
	) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;
	}

	changeStatus(): void {
		this.plansService.changeStatusSubject.next(this.elementInjected.key as number);
	}
}
